import { TAuthStep } from "franken-srp";

import { StatusOverlay } from "@smart/itops-sb-design-system-dom";

import { Code, UsernamePassword } from "../components";
import { LoginParams } from "../hooks";

type DisplayProps = {
  step: TAuthStep | undefined;
  start: (params: LoginParams) => void;
  next: (params: { code?: string }) => void;
  initial?: Partial<LoginParams>;
};

const Display = ({ step, start, next, initial }: DisplayProps) => {
  switch (step?.code) {
    case "TOKENS":
      return <StatusOverlay status="loading" errorCode="INF-2031" />;
    case "NEW_PASSWORD_REQUIRED":
      return <Code label="New Password" onVerify={next} />;
    case "SMS_MFA_REQUIRED":
      return <Code label="SMS Code" onVerify={next} />;
    case "SOFTWARE_MFA_REQUIRED":
      return <Code label="MFA Code" onVerify={next} />;
    default:
      return <UsernamePassword onLogin={start} initial={initial} />;
  }
};

export { Display, DisplayProps };
